module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"review_detail_title":"查看详细评价"}}')
  delete Component.options._Ctor
}
